export const ignoredExecutionTime = ['00:00', '23:59'];
